<div class="mct-flex mct-col mct-gap-32">
  <h2>{{ 'reports.NAHB-export.title' | translate | titlecase }}</h2>

  <div class="mct-flex mct-row mct-gap-16">
    <label>{{ 'reports.NAHB-export.new-changes-label' | translate | ucfirst }}</label>

    <div>{{ lastExportBatchDate }}</div>
  </div>
</div>

<hr />
<div class="mv-5">
  <a (click)="openValidationModal()">
    {{ 'reports.NAHB-export.view-validation-issues-label' | translate | titlecase }}
  </a>
</div>
<div class="atlas-table" style="max-width: 100vw">
  <p-table [showGridlines]="true"
    [value]="searchResult?.Result"
    [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [totalRecords]="searchResult?.TotalCount"
    (onLazyLoad)="lazyLoad($event)"
    [loading]="loading"
    [lazy]="true"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="ProfileId">
          {{ 'reports.NAHB-export.view-export-data.profile-id' | translate | ucfirst }}
          <p-sortIcon field="ProfileId"></p-sortIcon>
        </th>
        <th pSortableColumn="Transaction_Type">
          {{ 'reports.NAHB-export.view-export-data.transaction-type' | translate | ucfirst }}
          <p-sortIcon field="Transaction_Type"></p-sortIcon>
        </th>
        <th pSortableColumn="HBA_Number">
          {{ 'reports.NAHB-export.view-export-data.hba-number' | translate | ucfirst }}
          <p-sortIcon field="HBA_Number"></p-sortIcon>
        </th>
        <th pSortableColumn="Subscription_ID">
          {{ 'reports.NAHB-export.view-export-data.subscription-id' | translate | ucfirst }}
          <p-sortIcon field="Subscription_ID"></p-sortIcon>
        </th>
        <th pSortableColumn="Member_Type">
          {{ 'reports.NAHB-export.view-export-data.member-type' | translate | ucfirst }}
          <p-sortIcon field="Member_Type"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_Person_ID">
          {{ 'reports.NAHB-export.view-export-data.contact-person-id' | translate | ucfirst }}
          <p-sortIcon field="Contact_Person_ID"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_Prefix">
          {{ 'reports.NAHB-export.view-export-data.contact-prefix' | translate | ucfirst }}
          <p-sortIcon field="Contact_Prefix"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_First_Name">
          {{ 'reports.NAHB-export.view-export-data.contact-first-name' | translate | ucfirst }}
          <p-sortIcon field="Contact_Firs_tName"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_Middle_Name">
          {{ 'reports.NAHB-export.view-export-data.contact-middle-name' | translate | ucfirst }}
          <p-sortIcon field="Contact_Middle_Name"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_Last_Name">
          {{ 'reports.NAHB-export.view-export-data.contact-last-name' | translate | ucfirst }}
          <p-sortIcon field="Contact_Last_Name"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_Suffix">
          {{ 'reports.NAHB-export.view-export-data.contact-suffix' | translate | ucfirst }}
          <p-sortIcon field="Contact_Suffix"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_Title_Code">
          {{ 'reports.NAHB-export.view-export-data.contact-title-code' | translate | ucfirst }}
          <p-sortIcon field="Contact_TitleCode"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_Custom_Title">
          {{ 'reports.NAHB-export.view-export-data.contact-custom-title' | translate | ucfirst }}
          <p-sortIcon field="Contact_Custom_Title"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_Primary_Phone">
          {{ 'reports.NAHB-export.view-export-data.contact-primary-phone' | translate | ucfirst }}
          <p-sortIcon field="Contact_Primary_Phone"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_Primary_Fax">
          {{ 'reports.NAHB-export.view-export-data.contact-primary-fax' | translate | ucfirst }}
          <p-sortIcon field="Contact_Primary_Fax"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_Email">
          {{ 'reports.NAHB-export.view-export-data.contact-email' | translate | ucfirst }}
          <p-sortIcon field="Contact_Email"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_Address_Type">
          {{ 'reports.NAHB-export.view-export-data.contact-address-type' | translate | ucfirst }}
          <p-sortIcon field="Contact_Address_Type"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_Country">
          {{ 'reports.NAHB-export.view-export-data.contact-country' | translate | ucfirst }}
          <p-sortIcon field="Contact_Country"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_Address1">
          {{ 'reports.NAHB-export.view-export-data.contact-address1' | translate | ucfirst }}
          <p-sortIcon field="Contact_Address1"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_Address2">
          {{ 'reports.NAHB-export.view-export-data.contact-address2' | translate | ucfirst }}
          <p-sortIcon field="Contact_Address2"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_City">
          {{ 'reports.NAHB-export.view-export-data.contact-city' | translate | ucfirst }}
          <p-sortIcon field="Contact_City"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_State">
          {{ 'reports.NAHB-export.view-export-data.contact-state' | translate | ucfirst }}
          <p-sortIcon field="Contact_State"></p-sortIcon>
        </th>
        <th pSortableColumn="Contact_Zip">
          {{ 'reports.NAHB-export.view-export-data.contact-zip' | translate | ucfirst }}
          <p-sortIcon field="Contact_Zip"></p-sortIcon>
        </th>
        <th pSortableColumn="Company_ID">
          {{ 'reports.NAHB-export.view-export-data.company-id' | translate | ucfirst }}
          <p-sortIcon field="Company_ID"></p-sortIcon>
        </th>
        <th pSortableColumn="Company_Name">
          {{ 'reports.NAHB-export.view-export-data.company-name' | translate | ucfirst }}
          <p-sortIcon field="Company_Name"></p-sortIcon>
        </th>
        <th pSortableColumn="Company_Custom_Sort">
          {{ 'reports.NAHB-export.view-export-data.company-custom-sort' | translate | ucfirst }}
          <p-sortIcon field="Company_Custom_Sort"></p-sortIcon>
        </th>
        <th pSortableColumn="Company_Country">
          {{ 'reports.NAHB-export.view-export-data.company-country' | translate | ucfirst }}
          <p-sortIcon field="Company_Country"></p-sortIcon>
        </th>
        <th pSortableColumn="Company_Address_Line_1">
          {{ 'reports.NAHB-export.view-export-data.company-address-line1' | translate | ucfirst }}
          <p-sortIcon field="Company_Address_Line_1"></p-sortIcon>
        </th>
        <th pSortableColumn="Company_Address_Line_2">
          {{ 'reports.NAHB-export.view-export-data.company-address-line2' | translate | ucfirst }}
          <p-sortIcon field="Company_Address_Line_2"></p-sortIcon>
        </th>
        <th pSortableColumn="Company_City">
          {{ 'reports.NAHB-export.view-export-data.company-city' | translate | ucfirst }}
          <p-sortIcon field="Company_City"></p-sortIcon>
        </th>
        <th pSortableColumn="Company_State">
          {{ 'reports.NAHB-export.view-export-data.company-state' | translate | ucfirst }}
          <p-sortIcon field="Company_State"></p-sortIcon>
        </th>
        <th pSortableColumn="Company_Postal_Code">
          {{ 'reports.NAHB-export.view-export-data.company-postal-code' | translate | ucfirst }}
          <p-sortIcon field="Company_Postal_Code"></p-sortIcon>
        </th>
        <th pSortableColumn="Company_Phone">
          {{ 'reports.NAHB-export.view-export-data.company-phone' | translate | ucfirst }}
          <p-sortIcon field="Company_Phone"></p-sortIcon>
        </th>
        <th pSortableColumn="Company_Fax">
          {{ 'reports.NAHB-export.view-export-data.company-fax' | translate | ucfirst }}
          <p-sortIcon field="Company_Fax"></p-sortIcon>
        </th>
        <th pSortableColumn="Company_Website">
          {{ 'reports.NAHB-export.view-export-data.company-website' | translate | ucfirst }}
          <p-sortIcon field="Company_Website"></p-sortIcon>
        </th>
        <th pSortableColumn="Primary_Business_Activity_Code">
          {{ 'reports.NAHB-export.view-export-data.primary-business-activity-code' | translate | ucfirst }}
          <p-sortIcon field="Primary_Business_Activity_Code"></p-sortIcon>
        </th>
        <th pSortableColumn="Custom_Primary_Business_Activity">
          {{ 'reports.NAHB-export.view-export-data.custom-primary-business-activity' | translate | ucfirst }}
          <p-sortIcon field="Custom_Primary_Business_Activity"></p-sortIcon>
        </th>
        <th pSortableColumn="Secondary_Business_Activity_Code">
          {{ 'reports.NAHB-export.view-export-data.secondary-business-activity-code' | translate | ucfirst }}
          <p-sortIcon field="Secondary_Business_Activity_Code"></p-sortIcon>
        </th>
        <th pSortableColumn="Tertiary_Business_Activity_Code">
          {{ 'reports.NAHB-export.view-export-data.tertiary-business-activity-code' | translate | ucfirst }}
          <p-sortIcon field="Tertiary_Business_Activity_Code"></p-sortIcon>
        </th>
        <th pSortableColumn="Company_Number_Of_Employees">
          {{ 'reports.NAHB-export.view-export-data.company-number-of-employees' | translate | ucfirst }}
          <p-sortIcon field="Company_Number_Of_Employees"></p-sortIcon>
        </th>
        <th pSortableColumn="Dollar_Volume_Code">
          {{ 'reports.NAHB-export.view-export-data.dollar-volume-code' | translate | ucfirst }}
          <p-sortIcon field="Dollar_Volume_Code"></p-sortIcon>
        </th>
        <th pSortableColumn="Number_Of_Units_Code">
          {{ 'reports.NAHB-export.view-export-data.number-of-units-code' | translate | ucfirst }}
          <p-sortIcon field="Number_Of_Units_Code"></p-sortIcon>
        </th>
        <th pSortableColumn="Spike_Information_Entered">
          {{ 'reports.NAHB-export.view-export-data.spike-information-entered' | translate | ucfirst }}
          <p-sortIcon field="Spike_Information_Entered"></p-sortIcon>
        </th>
        <th pSortableColumn="Spike_HBA_Number">
          {{ 'reports.NAHB-export.view-export-data.spike-hba-number' | translate | ucfirst }}
          <p-sortIcon field="Spike_HBA_Number"></p-sortIcon>
        </th>
        <th pSortableColumn="Spike_Person_ID">
          {{ 'reports.NAHB-export.view-export-data.spike-person-id' | translate | ucfirst }}
          <p-sortIcon field="Spike_Person_ID"></p-sortIcon>
        </th>
        <th pSortableColumn="Spike_Prefix">
          {{ 'reports.NAHB-export.view-export-data.spike-prefix' | translate | ucfirst }}
          <p-sortIcon field="Spike_Prefix"></p-sortIcon>
        </th>
        <th pSortableColumn="Spike_First_Name">
          {{ 'reports.NAHB-export.view-export-data.spike-first-name' | translate | ucfirst }}
          <p-sortIcon field="Spike_First_Name"></p-sortIcon>
        </th>
        <th pSortableColumn="Spike_Middle_Name">
          {{ 'reports.NAHB-export.view-export-data.spike-middle-name' | translate | ucfirst }}
          <p-sortIcon field="Spike_Middle_Name"></p-sortIcon>
        </th>
        <th pSortableColumn="Spike_Last_Name">
          {{ 'reports.NAHB-export.view-export-data.spike-last-name' | translate | ucfirst }}
          <p-sortIcon field="Spike_Last_Name"></p-sortIcon>
        </th>
        <th pSortableColumn="Spike_Suffix">
          {{ 'reports.NAHB-export.view-export-data.spike-suffix' | translate | ucfirst }}
          <p-sortIcon field="Spike_Suffix"></p-sortIcon>
        </th>
        <th pSortableColumn="Spike_Company_ID">
          {{ 'reports.NAHB-export.view-export-data.spike-company-id' | translate | ucfirst }}
          <p-sortIcon field="Spike_Company_ID"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-nahbExport>
      <tr>
        <td>{{ nahbExport.ProfileId }}</td>
        <td>{{ nahbExport.Transaction_Type }}</td>
        <td>{{ nahbExport.HBA_Number }}</td>
        <td>{{ nahbExport.Subscription_ID }}</td>
        <td>{{ nahbExport.Member_Type }}</td>
        <td>{{ nahbExport.Contact_Person_ID }}</td>
        <td>{{ nahbExport.Contact_Prefix }}</td>
        <td>{{ nahbExport.Contact_First_Name }}</td>
        <td>{{ nahbExport.Contact_Middle_Name }}</td>
        <td>{{ nahbExport.Contact_Last_Name }}</td>
        <td>{{ nahbExport.Contact_Suffix }}</td>
        <td>{{ nahbExport.Contact_Title_Code }}</td>
        <td>{{ nahbExport.Contact_Custom_Title }}</td>
        <td>{{ nahbExport.Contact_Primary_Phone }}</td>
        <td>{{ nahbExport.Contact_Primary_Fax }}</td>
        <td>{{ nahbExport.Contact_Email }}</td>
        <td>{{ nahbExport.Contact_Address_Type }}</td>
        <td>{{ nahbExport.Contact_Country }}</td>
        <td>{{ nahbExport.Contact_Address1 }}</td>
        <td>{{ nahbExport.Contact_Address2 }}</td>
        <td>{{ nahbExport.Contact_City }}</td>
        <td>{{ nahbExport.Contact_State }}</td>
        <td>{{ nahbExport.Contact_Zip }}</td>
        <td>{{ nahbExport.Company_ID }}</td>
        <td>{{ nahbExport.Company_Name }}</td>
        <td>{{ nahbExport.Company_Custom_Sort }}</td>
        <td>{{ nahbExport.Company_Country }}</td>
        <td>{{ nahbExport.Company_Address_Line_1 }}</td>
        <td>{{ nahbExport.Company_Address_Line_2 }}</td>
        <td>{{ nahbExport.Company_City }}</td>
        <td>{{ nahbExport.Company_State }}</td>
        <td>{{ nahbExport.Company_Postal_Code }}</td>
        <td>{{ nahbExport.Company_Phone }}</td>
        <td>{{ nahbExport.Company_Fax }}</td>
        <td>{{ nahbExport.Company_Website }}</td>
        <td>{{ nahbExport.Primary_Business_Activity_Code }}</td>
        <td>{{ nahbExport.Custom_Primary_Business_Activity }}</td>
        <td>{{ nahbExport.Secondary_Business_Activity_Code }}</td>
        <td>{{ nahbExport.Tertiary_Business_Activity_Code }}</td>
        <td>{{ nahbExport.Company_Number_Of_Employees }}</td>
        <td>{{ nahbExport.Dollar_Volume_Code }}</td>
        <td>{{ nahbExport.Number_Of_Units_Code }}</td>
        <td>{{ nahbExport.Spike_Information_Entered }}</td>
        <td>{{ nahbExport.Spike_HBA_Number }}</td>
        <td>{{ nahbExport.Spike_Person_ID }}</td>
        <td>{{ nahbExport.Spike_Prefix }}</td>
        <td>{{ nahbExport.Spike_First_Name }}</td>
        <td>{{ nahbExport.Spike_Middle_Name }}</td>
        <td>{{ nahbExport.Spike_Last_Name }}</td>
        <td>{{ nahbExport.Spike_Suffix }}</td>
        <td>{{ nahbExport.Spike_Company_ID }}</td>
      </tr>
    </ng-template>
  </p-table>
  <wl-page-size-dropdown
    [(pageSize)]="searchParams.PageSize"
    [pageSizes]="[20, 100, 0]"
    (pageSizeChange)="pageSizeChanged()"
  ></wl-page-size-dropdown>
</div>

<div class="mct-flex mct-row mct-gap-16">
  <wl-busy [show]="exporting"></wl-busy>
  <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="exportResults()">
    {{ 'reports.NAHB-export.export' | translate | uppercase }}
  </button>
</div>
<wl-nahb-export-validation-modal [validationIssues]="validationIssues"></wl-nahb-export-validation-modal>
